import React from 'react';
import { IconButton } from '../../../../CommonComponents/OPL/IconButton/IconButton';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

export interface Props {
  assetName: string;
  onEdit(): void;
  onDelete(): void;
}

export const TableActions = ({ assetName, onEdit, onDelete }: Props) => {
  return (
    <Box as="td" css="text-align: right">
      <IconButton
        icon="far fa-pencil"
        variant="subtleInactive"
        onClick={onEdit}
        aria-label={`Edit ${assetName}`}
      />

      <IconButton
        icon="far fa-minus-circle"
        variant="subtleInactive"
        onClick={onDelete}
        aria-label={`Delete ${assetName}`}
      />
    </Box>
  );
};
